import { NodeShape } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { BEDTO } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { PartShape } from '../../BaseShape/PartShape';
import { MDAConstant } from '../../Base/MDAConstant';
import { BaseElement } from '../../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { EnumErrorLevel } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumErrorLevel';
import { DTOAttribute } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DTOAttribute';
import { ValidationResult } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { ValidationResultHelper } from '../../Base/ValidationResultHelper';
import { ValidateHelper } from '../../../../Product/IDE/Util/ValidateHelper';
import { MDShape } from '../../BaseShape/MDShape';
import { Diagram } from '../Diagram';
import { MDExtendService } from '../../../MD/MDExtendService';
import { Double2D } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/Double2D';
import { BEComponent } from '../../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { EnumPersistenceStatus } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { EnumDisplayLanguage } from '../../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { EnumDataType } from '../../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { ShapeModel } from '../../BaseShape/ShapeModel';
import { DataTypeManager } from '../../../MD/DataTypeManager';
import { MDValidation } from '../../../MD/MDValidation';
import { MDRepository } from '../../../MD/MDRepository';

export class JointDTOShape extends PartShape {
  constructor(attributes?: any, opt?: any) {
    super(attributes, opt);
    // this.id = this.curEntity.designId;
    this.set('type', 'mst.JointDTOShape');
    this.attr({
      '.uml-type-icon': { xlinkHref: '/imgs/icons/icon_DTO.png' }
    });
    // 反序列化调用，手工创建的时候不调用
    if (attributes) {
      this.setMD(attributes?.shape, attributes?.model.element, true);
    }
  }

  public setMD(elementShape: NodeShape, element: BEDTO, isFromJSON: boolean) {
    if (element) {
      MDExtendService.setElementListSequence(element.attributes, false);
    }
    this.setBaseMD(elementShape, this.createModel(element, !elementShape.isExpend), isFromJSON);
  }

  public shapeType(): string {
    return MDAConstant.Type.ADD_DTO;
  }

  get dto(): BEDTO {
    return this.element() as BEDTO;
  }

  doAction(action: string, designId?: string): BaseElement | null {
    let element = super.doAction(action, designId);
    switch (action) {
      // 添加属性
      case 'shape:addAttribute':
        element = this.addAttribute();
        break;
      case 'shape:deleteChild':
        element = this.deleteChild(designId);
        break;
      default:
        break;
    }
    this.refresh();
    return element;
  }

  /** 根据链接的类型，设置鼠标的样式 */
  setLinkType(linkType: string) {
    if (linkType === MDAConstant.Link.ADD_COMPOSITION || linkType === MDAConstant.Link.ADD_AGGREGATION || linkType === MDAConstant.Link.ADD_GENERALIZATION ||
        linkType === MDAConstant.Link.ADD_ASSOCIATION || linkType === MDAConstant.Link.ADD_DEPENDENCY || linkType === MDAConstant.Link.ADD_IMPLEMENT) {
      this.attr({ '.uml-class-container': { cursor: 'not-allowed' }, '.uml-class-name-text': { cursor: 'not-allowed' } });
    } else {
      this.attr({ '.uml-class-container': { cursor: 'move' }, '.uml-class-name-text': { cursor: 'move' } });
    }
  }

  protected getDisplayTitle(element: BaseElement) {
    let title = element.displayName;
    if (element instanceof DTOAttribute) {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = `${element.name}:${this.getDataType(element.dataType, element.referenceType)}`;
      } else {
        title = `${element.displayName}:${this.getDataType(element.dataType, element.referenceType)}`;
      }
    } else {
      if (this.displayLanguage === EnumDisplayLanguage.English) {
        title = element.name;
      } else {
        title = element.displayName;
      }
    }
    return title;
  }

  private addAttribute(): DTOAttribute {
    const attribute = MDRepository.createDTOAttribute(this.dto);
    MDExtendService.setElementListSequence(this.dto.attributes, true);
    this.model().compartments[0].push(attribute);
    return attribute;
  }

  /** 删除子元素及对应的行 */
  private deleteChild(designId: string): BaseElement | null {
    let element: BaseElement = null;
    element = this.dto.attributes.find(item => item.designId === designId);
    if (element) {
      // 新建状态的，需要从元数据中删除
      if (element.persistenceStatus === EnumPersistenceStatus.Create) {
        this.dto.attributes.splice(this.dto.attributes.findIndex(item => item.designId === element.designId), 1);
      } else {
        element.persistenceStatus = EnumPersistenceStatus.Delete;
      }
      return this.deleteRow(designId);
    }
    return null;
  }

  /** 设置图形的Model */
  private createModel(dto: BEDTO, isCollapse = false): ShapeModel {
    const model = new ShapeModel(dto, isCollapse);
    model.addCompartment(dto.attributes.filter(item => item.persistenceStatus !== EnumPersistenceStatus.Delete));
    return model;
  }

  /**
   * 克隆图形，包括图形内部所有元素，不包括与其他图形的关系
   * @param diagram 克隆后所属的图表
   * @param elements 克隆的所有元数据都插入数组返回
   */
  public cloneShape(diagram: Diagram, elements: Array<BaseElement>): MDShape {
    const jShape = new JointDTOShape();

    const newShape = new NodeShape();
    newShape.copyFrom(this.shape(), false);
    MDExtendService.setCreateInfo(newShape);
    newShape.startPoint = new Double2D(this.position().x + 20, this.position().y + 20);
    newShape.diagram_ID = diagram.diagramShape.id;
    diagram.diagramShape.nodeShapes.push(newShape);

    const newElement = new BEDTO();
    newElement.copyFrom(this.dto, false);
    MDExtendService.setCreateInfo(newElement);
    elements.push(newElement);
    if (diagram.component instanceof BEComponent) {
      newElement.component_ID = diagram.component.id;
      diagram.component.dTOes.push(newElement);
    }

    this.dto.attributes.forEach(item => {
      const attribute = new DTOAttribute();
      attribute.copyFrom(item, false);
      MDExtendService.setCreateInfo(attribute);
      attribute.dTO_ID = newElement.id;
      newElement.attributes.push(attribute);
      elements.push(attribute);
    });

    newShape.elementId = newElement.designId;
    jShape.setMD(newShape, newElement, false);
    diagram.cells.push(jShape);
    return jShape;
  }

  public addChildClone(element: BaseElement, elements: Array<BaseElement>): DTOAttribute | null {
    let newElement: DTOAttribute | null = null;
    if (element instanceof DTOAttribute) {
      newElement = new DTOAttribute();
      newElement.copyFrom(element, false);
      MDExtendService.setCreateInfo(newElement);
      newElement.dTO_ID = this.dto.id;
      this.dto.attributes.push(newElement);
      elements.push(newElement);
    }
    return newElement;
  }

  /**
   * 校验模型
   * 1. DTO
   *    - 必须包含至少一个属性
   *    - 必须以大写字母DTO结尾
   * 2. 属性
   *    - 属性必须填写名称
   *    - 属性必须填写显示名称
   *    - 必须选择引用数据类型
   *    - 不能存在同名属性
   *    - 数据类型不允许为空，则必须缺省值
   *    - 枚举类型必须设置缺省值
   */
  public validate(): Array<ValidationResult> {
    const errors = super.validate();
    const containerDesignId = this.dto.designId;
    MDValidation.validateBaseElement(this.dto, this.dto.designId, true, errors);
    if (!this.dto.name.endsWith('DTO')) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `DTO [${this.dto.displayName}] 的名称 [${this.dto.name}] 必须以大写字母DTO结尾`));
    }
    if (this.dto.attributes.length === 0) {
      errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, containerDesignId, `DTO [${this.dto.displayName}] 必须包含至少一个属性`));
    } else {
      this.dto.attributes.forEach(element => {
        MDValidation.validateBaseElement(element, containerDesignId, true, errors);
        if ((element.dataType === EnumDataType.Reference || element.dataType === EnumDataType.UniqueKey) && !ValidateHelper.IsNotNullOrEmpty(element.referenceType)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `DTO [${this.dto.displayName}] 的属性 [${element.displayName}] 必须选择引用数据类型`));
        }
        if (this.dto.attributes.find(item => element.designId !== item.designId && element.name === item.name)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `DTO [${this.dto.displayName}] 不能存在同名属性 [${element.name}]`));
        }
        // if (!element.isCollection && !DataTypeManager.instance.isNullable(element.dataType) && !ValidateHelper.IsNotNullOrEmpty(element.defaultValue)) {
        //   errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `DTO [${this.dto.displayName}] 的属性 [${element.displayName}] 数据类型要求必须设置缺省值`));
        // }
        if (!element.isCollection && ValidateHelper.IsEnum(element.dataType, element.referenceType) && !ValidateHelper.IsNotNullOrEmpty(element.defaultValue)) {
          errors.push(ValidationResultHelper.createResult(EnumErrorLevel.Error, containerDesignId, element.designId, `DTO [${this.dto.displayName}] 的属性 [${element.displayName}] 为枚举类型时必须设置缺省值`));
        }
      });
    }
    return errors;
  }
}
